/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Privacy_PolicyInputs */

const en_mobile_privacy_policy = /** @type {(inputs: Mobile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const es_mobile_privacy_policy = /** @type {(inputs: Mobile_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Privacidad`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Mobile_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_privacy_policy = /** @type {((inputs?: Mobile_Privacy_PolicyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Privacy_PolicyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_privacy_policy(inputs)
	return en_mobile_privacy_policy(inputs)
});